import { Tracker } from '@jbhi-fi/components/src/Tracking';
import { getStoreCurrency } from '@jbhi-fi/utils/src/shopify/getStoreCurrency';
import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';

export const useSmartModuleTracking = () => {
  const trackSmartModuleEvent = ({
    product,
    event,
    item_list_name,
    item_list_slot,
    item_list_service_config,
  }: {
    product: AlgoliaProductHit;
    event: string;
    googleRecModel?: string;
    item_list_name?: string;
    item_list_slot?: string;
    item_list_service_config?: string;
  }) => {
    Tracker.trackCustomEvent({
      event: event,
      currency: getStoreCurrency() || 'AUD',
      item_brand: product?.vendor,
      item_id: product?.sku,
      item_list_service_config: item_list_service_config,
      item_list_name: item_list_name,
      item_list_slot: item_list_slot,
      item_name: product?.title,
      price: product?.price,
    });
  };

  return { trackSmartModuleEvent };
};
